import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const login = async (email, password) => {
  try {
    const res = await axios.post(
      `${API_URL}/login`,
      { email, password },
      { withCredentials: true }
    );

    if (res.data.accessToken) {
      localStorage.setItem("token", res.data.accessToken);
      return res.data;
    }
  } catch (err) {
    console.error("Login failed:", err.response?.data || err.message);
    return null;
  }
};

export const refreshToken = async () => {
  try {
    const res = await axios.post(
      `${API_URL}/refresh`,
      {},
      { withCredentials: true }
    );

    if (res.data.accessToken) {
      localStorage.setItem("token", res.data.accessToken);
      return res.data.accessToken;
    }

    return null;
  } catch (err) {
    console.error(
      "Refresh token failed:",
      err.response?.data || err.message
    );

    return null;
  }
};